// ─── Mapping tipo copertura → branchCode ────────────────────────────────────

export function getBranchCode(tipo) {
  if (!tipo) return null;
  const t = tipo.toLowerCase();
  if (t.includes("rct") || t.includes("rco") || t.includes("verso terzi") || t.includes("prestatori")) return "rct_rco";
  if (t.includes("rc professionale") || t.includes("professionale")) return "rcp";
  if (t.includes("car") || t.includes("postuma")) return "car_postuma";
  if (t.includes("d&o") || t.includes("directors") || t.includes("organi sociali")) return "deo";
  if (t.includes("key man") || t.includes("uomo chiave") || t.includes("persona chiave")) return "key_man";
  if (t.includes("cyber")) return "cyber_risk";
  if (t.includes("tutela")) return "tutela_legale";
  if (t.includes("infortuni") || t.includes("malattia")) return "infortuni_malattia";
  if (t.includes("vettoriale") || t.includes("trasporto")) return "rc_vettoriale";
  return null;
}

// ─── Configurazioni questionari ─────────────────────────────────────────────

export const QUESTIONNAIRE_CONFIGS = {

  // ── RAMO 1: RCT/RCO ───────────────────────────────────────────────────────
  rct_rco: {
    label: "RCT / RCO — Responsabilità Civile verso Terzi e Prestatori d'Opera",
    quick: [
      {
        title: "Profilo del Rischio",
        questions: [
          { id: "rct_attivita_principale", text: "Attività principale", type: "text", required: false },
          { id: "rct_tipologia_clientela", text: "Tipologia di clientela", type: "select", required: true, options: ["Privati", "Aziende", "PA", "Mista"] },
          { id: "rct_opera_cantieri", text: "Opera in cantieri?", type: "select", required: true, options: ["Cantieri propri", "Presso terzi", "Entrambi", "Non opera"] },
          { id: "rct_numero_dipendenti_cat", text: "Numero dipendenti", type: "select", required: true, options: ["1-5", "6-15", "16-50", "51-100", "100+"] },
          { id: "rct_sinistri_ultimo_triennio", text: "Sinistri negli ultimi 5 anni?", type: "toggle", required: false },
          { id: "rct_num_sinistri_quick", text: "Quanti sinistri?", type: "number", required: true, condition: { field: "rct_sinistri_ultimo_triennio", value: true } },
          { id: "rct_sinistri_descrizione_quick", text: "Breve descrizione sinistri", type: "textarea", required: false, condition: { field: "rct_sinistri_ultimo_triennio", value: true } },
        ],
      },
    ],
    full: [
      {
        title: "Profilo del Rischio",
        questions: [
          { id: "rct_attivita_principale", text: "Attività principale", type: "textarea", required: false },
          { id: "rct_attivita_secondarie", text: "Attività secondarie", type: "textarea", required: false },
          { id: "rct_tipologia_clientela", text: "Tipologia di clientela", type: "select", required: true, options: ["Privati", "Aziende", "PA", "Mista"] },
          { id: "rct_percentuale_export", text: "Percentuale export (%)", type: "number", required: false },
          { id: "rct_opera_cantieri", text: "Opera in cantieri?", type: "select", required: true, options: ["Cantieri propri", "Presso terzi", "Entrambi", "Non opera"] },
          { id: "rct_cantieri_tipo", text: "Tipologie di cantieri", type: "multiselect", required: false, options: ["Edile residenziale", "Edile industriale", "Infrastrutturale", "Impianti", "Restauro"], condition: { field: "rct_opera_cantieri", value: "Cantieri propri" } },
          { id: "rct_cantieri_dimensione", text: "Dimensione tipica cantiere", type: "select", required: false, options: ["< €100k", "€100k–€500k", "€500k–€2M", "> €2M"], condition: { field: "rct_opera_cantieri", value: "Cantieri propri" } },
          { id: "rct_uso_subappalto", text: "Utilizzo subappalto?", type: "toggle", required: true },
          { id: "rct_percentuale_subappalto", text: "Percentuale subappalto (%)", type: "number", required: false, condition: { field: "rct_uso_subappalto", value: true } },
          { id: "rct_qualifica_subappaltatori", text: "Subappaltatori qualificati/assicurati?", type: "select", required: false, options: ["Sì", "No", "Parzialmente"], condition: { field: "rct_uso_subappalto", value: true }, alert: { type: "critical", message: "Subappaltatori non qualificati — rischio critico" } },
          { id: "rct_materiali_pericolosi", text: "Utilizzo materiali pericolosi?", type: "toggle", required: true },
          { id: "rct_materiali_dettaglio", text: "Descrizione materiali pericolosi", type: "textarea", required: false, condition: { field: "rct_materiali_pericolosi", value: true } },
        ],
      },
      {
        title: "Dettagli Operativi",
        questions: [
          { id: "rct_num_dipendenti", text: "Numero totale dipendenti", type: "number", required: true },
          { id: "rct_dipendenti_operai", text: "di cui operai", type: "number", required: false },
          { id: "rct_dipendenti_impiegati", text: "di cui impiegati", type: "number", required: false },
          { id: "rct_lavoratori_interinali", text: "Lavoratori interinali?", type: "toggle", required: false },
          { id: "rct_num_interinali", text: "Numero lavoratori interinali", type: "number", required: false, condition: { field: "rct_lavoratori_interinali", value: true } },
          { id: "rct_mezzi_aziendali", text: "Mezzi aziendali utilizzati", type: "multiselect", required: false, options: ["Autovetture", "Furgoni", "Camion", "Mezzi d'opera", "Carrelli elevatori", "Nessuno"] },
          { id: "rct_locali_aperti_pubblico", text: "Locali aperti al pubblico?", type: "toggle", required: false },
          { id: "rct_mq_locali", text: "Superficie locali (mq)", type: "number", required: false, condition: { field: "rct_locali_aperti_pubblico", value: true } },
          { id: "rct_attivita_carico_scarico", text: "Attività di carico/scarico?", type: "toggle", required: false },
          { id: "rct_lavoro_altezza", text: "Lavori in quota?", type: "toggle", required: false },
          { id: "rct_altezza_max", text: "Altezza massima raggiunta", type: "select", required: false, options: ["< 5m", "5m–10m", "10m–20m", "> 20m"], condition: { field: "rct_lavoro_altezza", value: true } },
          { id: "rct_certificazioni", text: "Certificazioni possedute", type: "multiselect", required: false, options: ["ISO 9001", "ISO 14001", "ISO 45001", "SOA", "Nessuna"] },
          { id: "rct_piano_sicurezza", text: "Piano di sicurezza adottato?", type: "toggle", required: false },
          { id: "rct_rspp", text: "RSPP nominato?", type: "toggle", required: false },
        ],
      },
      {
        title: "Garanzie e Massimali",
        questions: [
          { id: "rct_massimale_rct", text: "Massimale RCT richiesto", type: "select", required: true, options: ["€500.000", "€1.000.000", "€2.000.000", "€3.000.000", "€5.000.000"] },
          { id: "rct_massimale_rco", text: "Massimale RCO richiesto", type: "select", required: true, options: ["€500.000", "€1.000.000", "€2.000.000", "€3.000.000", "€5.000.000"] },
          { id: "rct_massimale_per_persona", text: "Massimale per persona", type: "select", required: true, options: ["€250.000", "€500.000", "€1.000.000", "€2.000.000"] },
          { id: "rct_franchigia_preferita", text: "Franchigia preferita", type: "select", required: false, options: ["Nessuna", "€250", "€500", "€1.000", "€2.500"] },
          { id: "rct_estensione_postuma", text: "Estensione postuma?", type: "toggle", required: false },
          { id: "rct_estensione_prodotto", text: "RC Prodotti?", type: "toggle", required: false },
          { id: "rct_rc_prodotti_dettaglio", text: "Dettaglio prodotti commercializzati/installati", type: "textarea", required: false, condition: { field: "rct_estensione_prodotto", value: true } },
          { id: "rct_danni_cose_custodia", text: "Danni a cose in custodia?", type: "toggle", required: false },
          { id: "rct_danni_ambiente", text: "Estensione danni all'ambiente?", type: "toggle", required: false },
          { id: "rct_rc_veicoli_cantiere", text: "RC veicoli da cantiere?", type: "toggle", required: false },
          { id: "rct_garanzie_aggiuntive", text: "Garanzie aggiuntive richieste", type: "multiselect", required: false, options: ["RC committente", "RC incrociata", "Danni a impianti sotterranei", "Danni a condutture"] },
        ],
      },
      {
        title: "Sinistri e Storico",
        questions: [
          { id: "rct_sinistri_ultimo_triennio", text: "Sinistri negli ultimi 5 anni?", type: "toggle", required: false },
          { id: "rct_num_sinistri", text: "Numero sinistri", type: "number", required: false, condition: { field: "rct_sinistri_ultimo_triennio", value: true } },
          { id: "rct_sinistri_tabella", text: "Dettaglio sinistri", type: "claims_table", required: false, condition: { field: "rct_sinistri_ultimo_triennio", value: true } },
          { id: "rct_importo_totale_sinistri", text: "Importo totale sinistri", type: "currency", required: false, condition: { field: "rct_sinistri_ultimo_triennio", value: true } },
          { id: "rct_misure_prevenzione", text: "Misure di prevenzione adottate", type: "textarea", required: false, condition: { field: "rct_sinistri_ultimo_triennio", value: true } },
          { id: "rct_polizza_precedente", text: "Polizza precedente in scadenza?", type: "toggle", required: false },
          { id: "rct_compagnia_precedente", text: "Compagnia precedente", type: "text", required: false, condition: { field: "rct_polizza_precedente", value: true } },
          { id: "rct_motivo_cambio", text: "Motivo del cambio", type: "text", required: false, condition: { field: "rct_polizza_precedente", value: true } },
          { id: "rct_scadenza_precedente", text: "Data scadenza polizza precedente", type: "date", required: false, condition: { field: "rct_polizza_precedente", value: true } },
          { id: "rct_premio_precedente", text: "Premio polizza precedente", type: "currency", required: false, condition: { field: "rct_polizza_precedente", value: true } },
        ],
      },
    ],
  },

  // ── RAMO 2: RC Professionale ──────────────────────────────────────────────
  rcp: {
    label: "RC Professionale",
    quick: [
      {
        title: "Profilo Professionale",
        questions: [
          { id: "rcp_professione", text: "Professione svolta", type: "text", required: true },
          { id: "rcp_iscrizione_albo", text: "Iscritto a ordine/albo professionale?", type: "toggle", required: true },
          { id: "rcp_fatturato_professionale", text: "Fatturato professionale annuo", type: "currency", required: true },
          { id: "rcp_sinistri", text: "Sinistri/reclami professionali negli ultimi 5 anni?", type: "toggle", required: false },
        ],
      },
    ],
    full: [
      {
        title: "Profilo Professionale",
        questions: [
          { id: "rcp_professione", text: "Professione svolta", type: "text", required: true },
          { id: "rcp_specializzazione", text: "Specializzazione / area di attività", type: "text", required: false },
          { id: "rcp_iscrizione_albo", text: "Iscritto a ordine/albo professionale?", type: "toggle", required: true },
          { id: "rcp_anno_inizio_attivita", text: "Anno di inizio attività", type: "number", required: true },
          { id: "rcp_forma_esercizio", text: "Forma di esercizio", type: "select", required: true, options: ["Libero professionista", "STP", "Studio associato", "Società"] },
          { id: "rcp_num_professionisti", text: "Numero professionisti nello studio", type: "number", required: true },
          { id: "rcp_fatturato_professionale", text: "Fatturato professionale annuo", type: "currency", required: true },
        ],
      },
      {
        title: "Attività e Clientela",
        questions: [
          { id: "rcp_area_geografica", text: "Area geografica di operatività", type: "select", required: true, options: ["Locale", "Regionale", "Nazionale", "Internazionale"] },
          { id: "rcp_tipo_clienti", text: "Tipologia clienti prevalente", type: "select", required: true, options: ["Privati", "Aziende", "PA", "Misti"] },
          { id: "rcp_attivita_rischiose", text: "Attività particolarmente rischiose o innovative?", type: "toggle", required: false },
          { id: "rcp_attivita_rischiose_dettaglio", text: "Descrvere le attività rischiose", type: "textarea", required: false, condition: { field: "rcp_attivita_rischiose", value: true } },
          { id: "rcp_subappalto_incarichi", text: "Subappalto parziale di incarichi?", type: "toggle", required: false },
          { id: "rcp_subappalto_dettaglio", text: "Dettaglio subappalto incarichi", type: "textarea", required: false, condition: { field: "rcp_subappalto_incarichi", value: true } },
        ],
      },
      {
        title: "Garanzie e Massimali",
        questions: [
          { id: "rcp_massimale", text: "Massimale richiesto", type: "select", required: true, options: ["€250.000", "€500.000", "€1.000.000", "€2.000.000", "€5.000.000"] },
          { id: "rcp_retroattivita", text: "Retroattività richiesta", type: "select", required: false, options: ["Nessuna", "1 anno", "3 anni", "5 anni", "Illimitata"] },
          { id: "rcp_postuma", text: "Copertura postuma?", type: "toggle", required: false, helpText: "Copre i sinistri denunciati dopo la cessazione dell'attività" },
        ],
      },
      {
        title: "Sinistri e Storico",
        questions: [
          { id: "rcp_sinistri", text: "Sinistri/reclami professionali negli ultimi 5 anni?", type: "toggle", required: false },
          { id: "rcp_num_sinistri", text: "Numero sinistri", type: "number", required: false, condition: { field: "rcp_sinistri", value: true } },
          { id: "rcp_sinistri_tabella", text: "Dettaglio sinistri", type: "claims_table", required: false, condition: { field: "rcp_sinistri", value: true } },
          { id: "rcp_polizza_precedente", text: "Polizza precedente in scadenza?", type: "toggle", required: false },
          { id: "rcp_compagnia_precedente", text: "Compagnia precedente", type: "text", required: false, condition: { field: "rcp_polizza_precedente", value: true } },
          { id: "rcp_motivo_cambio", text: "Motivo del cambio", type: "text", required: false, condition: { field: "rcp_polizza_precedente", value: true } },
        ],
      },
    ],
  },

  // ── RAMO 3: CAR / Postuma Decennale ──────────────────────────────────────
  car_postuma: {
    label: "CAR / Postuma Decennale",
    quick: [
      {
        title: "Dati Opera",
        questions: [
          { id: "car_tipo_opera", text: "Tipo di opera", type: "select", required: true, options: ["Residenziale", "Industriale", "Commerciale", "Infrastrutture", "Impianti"] },
          { id: "car_valore_opera", text: "Valore dell'opera", type: "currency", required: true },
          { id: "car_durata_lavori", text: "Durata lavori prevista (mesi)", type: "number", required: true },
          { id: "car_committente", text: "Nome committente", type: "text", required: true },
        ],
      },
    ],
    full: [
      {
        title: "Dati Opera",
        questions: [
          { id: "car_tipo_opera", text: "Tipo di opera", type: "select", required: true, options: ["Residenziale", "Industriale", "Commerciale", "Infrastrutture", "Impianti", "Restauro/Ristrutturazione"] },
          { id: "car_descrizione_opera", text: "Descrizione dell'opera", type: "textarea", required: true },
          { id: "car_valore_opera", text: "Valore dell'opera", type: "currency", required: true },
          { id: "car_indirizzo_cantiere", text: "Indirizzo del cantiere", type: "text", required: true },
          { id: "car_durata_lavori", text: "Durata lavori prevista (mesi)", type: "number", required: true },
          { id: "car_committente", text: "Nome committente", type: "text", required: true },
          { id: "car_impresa_principale", text: "Impresa principale esecutrice", type: "text", required: true },
        ],
      },
      {
        title: "Dettagli Costruttivi",
        questions: [
          { id: "car_num_imprese", text: "Numero di imprese coinvolte", type: "number", required: true },
          { id: "car_lavorazioni_speciali", text: "Lavorazioni speciali previste", type: "multiselect", required: false, options: ["Fondazioni speciali", "Demolizioni", "Lavori in quota > 5m", "Opere di scavo", "Impermeabilizzazioni", "Nessuna"] },
          { id: "car_preesistenze", text: "Presenza di preesistenze adiacenti o interferenti?", type: "toggle", required: false },
          { id: "car_valore_preesistenze", text: "Valore delle preesistenze", type: "currency", required: false, condition: { field: "car_preesistenze", value: true } },
        ],
      },
      {
        title: "Sezioni e Massimali",
        questions: [
          { id: "car_sezione_I", text: "Sezione I — Danni all'opera in costruzione", type: "toggle", required: false, helpText: "Copre i danni materiali e diretti all'opera assicurata durante la costruzione" },
          { id: "car_sezione_II", text: "Sezione II — RC verso terzi (RC cantiere)", type: "toggle", required: false, helpText: "Copre i danni causati a terzi durante i lavori" },
          { id: "car_sezione_III", text: "Sezione III — Postuma decennale", type: "toggle", required: false, helpText: "Copre i gravi difetti costruttivi per 10 anni dalla fine lavori" },
          { id: "car_massimale_rc", text: "Massimale RC terzi richiesto", type: "select", required: false, options: ["€500.000", "€1.000.000", "€2.000.000", "€5.000.000", "€10.000.000"] },
        ],
      },
      {
        title: "Sinistri e Storico",
        questions: [
          { id: "car_sinistri", text: "Sinistri su opere precedenti?", type: "toggle", required: false },
          { id: "car_num_sinistri", text: "Numero sinistri", type: "number", required: false, condition: { field: "car_sinistri", value: true } },
          { id: "car_sinistri_tabella", text: "Dettaglio sinistri", type: "claims_table", required: false, condition: { field: "car_sinistri", value: true } },
        ],
      },
    ],
  },

  // ── RAMO 4: D&O ──────────────────────────────────────────────────────────
  deo: {
    label: "D&O — Directors & Officers",
    quick: [
      {
        title: "Profilo Societario",
        questions: [
          { id: "deo_tipo_societa", text: "Tipo di società", type: "select", required: true, options: ["SRL", "SPA", "Cooperativa", "Associazione", "Fondazione", "Altro"] },
          { id: "deo_num_amministratori", text: "Numero amministratori", type: "number", required: true },
          { id: "deo_quotata", text: "Società quotata in borsa?", type: "toggle", required: false },
          { id: "deo_contenziosi", text: "Contenziosi in corso contro organi sociali?", type: "toggle", required: false },
        ],
      },
    ],
    full: [
      {
        title: "Struttura Societaria",
        questions: [
          { id: "deo_tipo_societa", text: "Tipo di società", type: "select", required: true, options: ["SRL", "SPA", "Cooperativa", "Associazione", "Fondazione", "Altro"] },
          { id: "deo_num_amministratori", text: "Numero amministratori (CDA)", type: "number", required: true },
          { id: "deo_num_sindaci", text: "Numero sindaci/revisori", type: "number", required: false },
          { id: "deo_quotata", text: "Società quotata in borsa?", type: "toggle", required: false },
          { id: "deo_controllate", text: "Presenza di società controllate?", type: "toggle", required: false },
          { id: "deo_num_controllate", text: "Numero di controllate", type: "number", required: false, condition: { field: "deo_controllate", value: true } },
        ],
      },
      {
        title: "Situazione Finanziaria",
        questions: [
          { id: "deo_bilancio_positivo", text: "Bilancio degli ultimi 2 anni positivo?", type: "toggle", required: true },
          { id: "deo_situazione_finanziaria", text: "Situazione finanziaria attuale", type: "select", required: true, options: ["Ottima", "Buona", "Sufficiente", "Con difficoltà"] },
          { id: "deo_operazioni_straordinarie", text: "Operazioni straordinarie recenti o in corso", type: "multiselect", required: false, options: ["M&A", "Fusione", "Scissione", "Aumento di capitale", "Nessuna"] },
        ],
      },
      {
        title: "Garanzie e Massimali",
        questions: [
          { id: "deo_massimale", text: "Massimale richiesto", type: "select", required: true, options: ["€500.000", "€1.000.000", "€2.000.000", "€5.000.000", "€10.000.000"] },
          { id: "deo_retroattivita", text: "Retroattività richiesta", type: "select", required: false, options: ["Nessuna", "1 anno", "3 anni", "5 anni", "Illimitata"] },
        ],
      },
      {
        title: "Contenziosi e Storico",
        questions: [
          { id: "deo_contenziosi", text: "Contenziosi in corso contro organi sociali?", type: "toggle", required: false },
          { id: "deo_num_contenziosi", text: "Numero di contenziosi", type: "number", required: false, condition: { field: "deo_contenziosi", value: true } },
          { id: "deo_contenziosi_dettaglio", text: "Descrizione contenziosi in corso", type: "textarea", required: false, condition: { field: "deo_contenziosi", value: true } },
        ],
      },
    ],
  },

  // ── RAMO 5: Key Man ───────────────────────────────────────────────────────
  key_man: {
    label: "Key Man — Assicurazione Persona Chiave",
    quick: [
      {
        title: "Profilo Persona Chiave",
        questions: [
          { id: "km_ruolo", text: "Ruolo nella società", type: "text", required: true },
          { id: "km_eta", text: "Età", type: "number", required: true },
          { id: "km_impatto_assenza", text: "Impatto dell'assenza sull'attività", type: "select", required: true, options: ["Critico", "Alto", "Medio", "Basso"] },
        ],
      },
    ],
    full: [
      {
        title: "Profilo Persona Chiave",
        questions: [
          { id: "km_ruolo", text: "Ruolo nella società", type: "text", required: true },
          { id: "km_eta", text: "Età", type: "number", required: true },
          { id: "km_stato_salute", text: "Stato di salute generale", type: "select", required: true, options: ["Buono", "Discreto", "Con patologie"] },
          { id: "km_sostituibilita", text: "Sostituibilità della figura", type: "select", required: true, options: ["Non sostituibile", "Difficilmente sostituibile", "Sostituibile con ricerca"] },
        ],
      },
      {
        title: "Impatto Economico",
        questions: [
          { id: "km_perc_fatturato", text: "% di fatturato attribuibile a questa figura (%)", type: "number", required: true },
          { id: "km_competenze_esclusive", text: "Competenze esclusive / know-how non trasferibile?", type: "toggle", required: false },
          { id: "km_competenze_descrizione", text: "Descrizione competenze esclusive", type: "textarea", required: false, condition: { field: "km_competenze_esclusive", value: true } },
          { id: "km_piano_successione", text: "Piano di successione esistente?", type: "toggle", required: false },
        ],
      },
      {
        title: "Capitali Assicurati",
        questions: [
          { id: "km_capitale_morte", text: "Capitale in caso di morte", type: "currency", required: true },
          { id: "km_capitale_invalidita", text: "Capitale in caso di invalidità permanente", type: "currency", required: false },
          { id: "km_indennita_inabilita_temporanea", text: "Indennità giornaliera per inabilità temporanea", type: "currency", required: false },
        ],
      },
      {
        title: "Storico Assicurativo",
        questions: [
          { id: "km_polizza_precedente", text: "Polizza Key Man precedente in scadenza?", type: "toggle", required: false },
          { id: "km_compagnia_precedente", text: "Compagnia precedente", type: "text", required: false, condition: { field: "km_polizza_precedente", value: true } },
          { id: "km_scadenza_precedente", text: "Data scadenza polizza precedente", type: "date", required: false, condition: { field: "km_polizza_precedente", value: true } },
          { id: "km_premio_precedente", text: "Premio polizza precedente", type: "currency", required: false, condition: { field: "km_polizza_precedente", value: true } },
        ],
      },
    ],
  },

  // ── RAMO 6: Cyber Risk ────────────────────────────────────────────────────
  cyber_risk: {
    label: "Cyber Risk",
    quick: [
      {
        title: "Profilo Cyber",
        questions: [
          { id: "cy_tratta_dati_personali", text: "Tratta dati personali di clienti/dipendenti?", type: "toggle", required: false },
          { id: "cy_ecommerce", text: "Gestisce piattaforma e-commerce o pagamenti online?", type: "toggle", required: false },
          { id: "cy_volume_dati", text: "Volume di dati personali trattati", type: "select", required: true, options: ["< 1.000 record", "1.000–10.000", "10.000–100.000", "> 100.000"] },
          { id: "cy_incidenti_precedenti", text: "Incidenti informatici negli ultimi 3 anni?", type: "toggle", required: false },
        ],
      },
    ],
    full: [
      {
        title: "Dati e Operatività Digitale",
        questions: [
          { id: "cy_tratta_dati_personali", text: "Tratta dati personali di clienti/dipendenti?", type: "toggle", required: false },
          { id: "cy_tipo_dati", text: "Tipologia dati trattati", type: "multiselect", required: false, options: ["Dati comuni", "Dati sensibili (salute, religione…)", "Dati bancari/finanziari", "Dati di minori"], condition: { field: "cy_tratta_dati_personali", value: true } },
          { id: "cy_volume_dati", text: "Volume di dati personali trattati", type: "select", required: true, options: ["< 1.000 record", "1.000–10.000", "10.000–100.000", "> 100.000"] },
          { id: "cy_ecommerce", text: "Gestisce piattaforma e-commerce o pagamenti online?", type: "toggle", required: false },
          { id: "cy_fatturato_online", text: "Fatturato generato online", type: "currency", required: false, condition: { field: "cy_ecommerce", value: true } },
        ],
      },
      {
        title: "Sicurezza IT",
        questions: [
          { id: "cy_firewall", text: "Firewall attivo e aggiornato?", type: "toggle", required: false },
          { id: "cy_antivirus", text: "Antivirus/EDR attivo su tutti i dispositivi?", type: "toggle", required: false },
          { id: "cy_backup", text: "Backup regolari dei dati aziendali?", type: "toggle", required: false },
          { id: "cy_backup_frequenza", text: "Frequenza backup", type: "select", required: false, options: ["Giornaliero", "Settimanale", "Mensile"], condition: { field: "cy_backup", value: true } },
          { id: "cy_mfa", text: "MFA (autenticazione a più fattori) attiva?", type: "toggle", required: false },
          { id: "cy_formazione_dipendenti", text: "Formazione periodica dipendenti su cyber security?", type: "toggle", required: false },
          { id: "cy_responsabile_IT", text: "Responsabile IT interno o MSSP esterno?", type: "toggle", required: false },
          { id: "cy_cloud", text: "Utilizzo di servizi cloud?", type: "toggle", required: false },
          { id: "cy_cloud_provider", text: "Provider cloud principale", type: "text", required: false, condition: { field: "cy_cloud", value: true } },
        ],
      },
      {
        title: "Garanzie e Massimali",
        questions: [
          { id: "cy_massimale", text: "Massimale richiesto", type: "select", required: true, options: ["€250.000", "€500.000", "€1.000.000", "€2.000.000", "€5.000.000"] },
          { id: "cy_business_interruption", text: "Copertura Business Interruption da incidente cyber?", type: "toggle", required: false },
          { id: "cy_cyber_extortion", text: "Copertura Cyber Extortion (ransomware)?", type: "toggle", required: false },
          { id: "cy_data_breach_response", text: "Copertura Data Breach Response (notifiche GDPR)?", type: "toggle", required: false },
        ],
      },
      {
        title: "Incidenti e Storico",
        questions: [
          { id: "cy_incidenti_precedenti", text: "Incidenti informatici negli ultimi 3 anni?", type: "toggle", required: false },
          { id: "cy_incidenti_dettaglio", text: "Descrizione incidenti", type: "textarea", required: false, condition: { field: "cy_incidenti_precedenti", value: true } },
          { id: "cy_polizza_precedente", text: "Polizza cyber precedente in scadenza?", type: "toggle", required: false },
          { id: "cy_compagnia_precedente", text: "Compagnia precedente", type: "text", required: false, condition: { field: "cy_polizza_precedente", value: true } },
          { id: "cy_premio_precedente", text: "Premio polizza precedente", type: "currency", required: false, condition: { field: "cy_polizza_precedente", value: true } },
        ],
      },
    ],
  },

  // ── RAMO 7: Tutela Legale ─────────────────────────────────────────────────
  tutela_legale: {
    label: "Tutela Legale",
    quick: [
      {
        title: "Profilo Legale",
        questions: [
          { id: "tl_ambito", text: "Ambito di tutela richiesto", type: "multiselect", required: true, options: ["Contrattuale", "Lavoro", "Fiscale", "Penale", "Amministrativo"] },
          { id: "tl_contenziosi_attivi", text: "Contenziosi legali attualmente in corso?", type: "toggle", required: false },
          { id: "tl_num_dipendenti", text: "Numero dipendenti", type: "number", required: true },
        ],
      },
    ],
    full: [
      {
        title: "Ambiti e Operatività",
        questions: [
          { id: "tl_ambito", text: "Ambiti di tutela richiesti", type: "multiselect", required: true, options: ["Contrattuale", "Lavoro", "Fiscale", "Penale", "Amministrativo", "Doganale"] },
          { id: "tl_rapporti_PA", text: "Frequenti rapporti con la Pubblica Amministrazione?", type: "toggle", required: false },
          { id: "tl_settore_regolamentato", text: "Operante in settore regolamentato (farmaceutico, energia, banche…)?", type: "toggle", required: false },
          { id: "tl_settore_regolamentato_desc", text: "Specificare il settore regolamentato", type: "text", required: false, condition: { field: "tl_settore_regolamentato", value: true } },
        ],
      },
      {
        title: "Attività Contrattuale",
        questions: [
          { id: "tl_num_contratti_anno", text: "Numero di contratti stipulati per anno", type: "number", required: false },
          { id: "tl_valore_medio_contratti", text: "Valore medio dei contratti", type: "currency", required: false },
        ],
      },
      {
        title: "Garanzie e Massimali",
        questions: [
          { id: "tl_massimale", text: "Massimale richiesto per sinistro", type: "select", required: true, options: ["€25.000", "€50.000", "€100.000", "€150.000", "€250.000"] },
        ],
      },
      {
        title: "Contenziosi Attivi",
        questions: [
          { id: "tl_contenziosi_attivi", text: "Contenziosi legali attualmente in corso?", type: "toggle", required: false },
          { id: "tl_num_contenziosi", text: "Numero di contenziosi in corso", type: "number", required: false, condition: { field: "tl_contenziosi_attivi", value: true } },
          { id: "tl_contenziosi_dettaglio", text: "Descrizione contenziosi", type: "textarea", required: false, condition: { field: "tl_contenziosi_attivi", value: true } },
        ],
      },
    ],
  },

  // ── RAMO 8: Infortuni e Malattia ──────────────────────────────────────────
  infortuni_malattia: {
    label: "Infortuni e Malattia",
    quick: [
      {
        title: "Profilo Assicurati",
        questions: [
          { id: "inf_num_assicurati", text: "Numero di dipendenti da assicurare", type: "number", required: true },
          { id: "inf_categorie", text: "Categorie da assicurare", type: "multiselect", required: true, options: ["Dirigenti", "Quadri", "Impiegati", "Operai"] },
          { id: "inf_attivita_rischio", text: "Presenza di attività ad alto rischio infortuni?", type: "toggle", required: false },
        ],
      },
    ],
    full: [
      {
        title: "Profilo Assicurati",
        questions: [
          { id: "inf_num_assicurati", text: "Numero totale di dipendenti da assicurare", type: "number", required: true },
          { id: "inf_categorie", text: "Categorie da assicurare", type: "multiselect", required: true, options: ["Dirigenti", "Quadri", "Impiegati", "Operai"] },
          { id: "inf_distribuzione", text: "Distribuzione per categoria (es. 10 dirigenti, 30 impiegati…)", type: "textarea", required: false },
          { id: "inf_eta_media", text: "Età media del personale", type: "number", required: false },
        ],
      },
      {
        title: "Attività e Rischi",
        questions: [
          { id: "inf_attivita_rischio", text: "Presenza di attività ad alto rischio infortuni?", type: "toggle", required: false },
          { id: "inf_tipo_rischio", text: "Tipo di attività rischiose", type: "multiselect", required: false, options: ["Cantieri/Edilizia", "Lavori in quota", "Movimentazione carichi", "Uso macchinari", "Lavori elettrici"], condition: { field: "inf_attivita_rischio", value: true } },
          { id: "inf_trasferte_estero", text: "Trasferte all'estero frequenti?", type: "toggle", required: false },
          { id: "inf_sport_aziendali", text: "Attività sportive aziendali (es. team building)?", type: "toggle", required: false },
        ],
      },
      {
        title: "Prestazioni Richieste",
        questions: [
          { id: "inf_capitale_morte", text: "Capitale caso morte (per assicurato)", type: "currency", required: false },
          { id: "inf_capitale_IP", text: "Capitale invalidità permanente (per assicurato)", type: "currency", required: false },
          { id: "inf_indennita_IT", text: "Indennità inabilità temporanea giornaliera", type: "currency", required: false },
          { id: "inf_diaria_ricovero", text: "Diaria da ricovero ospedaliero", type: "currency", required: false },
          { id: "inf_spese_mediche", text: "Rimborso spese mediche?", type: "toggle", required: false },
        ],
      },
      {
        title: "Sinistri e Storico",
        questions: [
          { id: "inf_sinistri", text: "Sinistri infortuni/malattia negli ultimi 5 anni?", type: "toggle", required: false },
          { id: "inf_num_sinistri", text: "Numero totale sinistri", type: "number", required: false, condition: { field: "inf_sinistri", value: true } },
          { id: "inf_polizza_precedente", text: "Polizza infortuni precedente in scadenza?", type: "toggle", required: false },
          { id: "inf_compagnia_precedente", text: "Compagnia precedente", type: "text", required: false, condition: { field: "inf_polizza_precedente", value: true } },
          { id: "inf_premio_precedente", text: "Premio polizza precedente", type: "currency", required: false, condition: { field: "inf_polizza_precedente", value: true } },
        ],
      },
    ],
  },

  // ── RAMO 9: RC Vettoriale ─────────────────────────────────────────────────
  rc_vettoriale: {
    label: "RC Vettoriale",
    quick: [
      {
        title: "Profilo Trasporto",
        questions: [
          { id: "rcv_tipo_trasporto", text: "Modalità di trasporto prevalente", type: "select", required: true, options: ["Strada", "Ferrovia", "Mare", "Aereo", "Multimodale"] },
          { id: "rcv_tipo_merce", text: "Tipo di merce trasportata", type: "text", required: true },
          { id: "rcv_num_mezzi", text: "Numero di mezzi propri", type: "number", required: true },
          { id: "rcv_sinistri", text: "Sinistri negli ultimi 5 anni?", type: "toggle", required: false },
        ],
      },
    ],
    full: [
      {
        title: "Profilo Operativo",
        questions: [
          { id: "rcv_tipo_trasporto", text: "Modalità di trasporto prevalente", type: "select", required: true, options: ["Strada", "Ferrovia", "Mare", "Aereo", "Multimodale"] },
          { id: "rcv_tipo_merce", text: "Tipo di merce trasportata", type: "text", required: true },
          { id: "rcv_area_operativita", text: "Area di operatività", type: "select", required: true, options: ["Locale", "Regionale", "Nazionale", "Internazionale"] },
          { id: "rcv_iscrizione_albo", text: "Iscrizione all'albo degli autotrasportatori?", type: "toggle", required: true },
        ],
      },
      {
        title: "Flotta e Volumi",
        questions: [
          { id: "rcv_num_mezzi", text: "Numero di mezzi propri", type: "number", required: true },
          { id: "rcv_tipo_mezzi", text: "Tipologia mezzi", type: "multiselect", required: false, options: ["Furgoni (< 3,5t)", "Camion leggeri (3,5–7t)", "Camion pesanti (7–26t)", "Autoarticolati/Bilici", "Cisterne"] },
          { id: "rcv_valore_medio_carico", text: "Valore medio del carico per spedizione", type: "currency", required: true },
          { id: "rcv_num_spedizioni_anno", text: "Numero spedizioni per anno", type: "number", required: true },
        ],
      },
      {
        title: "Garanzie e Massimali",
        questions: [
          { id: "rcv_massimale", text: "Massimale per sinistro", type: "select", required: true, options: ["€50.000", "€100.000", "€250.000", "€500.000", "€1.000.000"] },
          { id: "rcv_aggregato_annuo", text: "Massimale aggregato annuo", type: "select", required: false, options: ["€100.000", "€250.000", "€500.000", "€1.000.000", "€2.000.000"] },
        ],
      },
      {
        title: "Sinistri e Storico",
        questions: [
          { id: "rcv_sinistri", text: "Sinistri negli ultimi 5 anni?", type: "toggle", required: true },
          { id: "rcv_num_sinistri", text: "Numero totale sinistri", type: "number", required: false, condition: { field: "rcv_sinistri", value: true } },
          { id: "rcv_importo_totale_sinistri", text: "Importo totale sinistri", type: "currency", required: false, condition: { field: "rcv_sinistri", value: true } },
          { id: "rcv_polizza_precedente", text: "Polizza precedente in scadenza?", type: "toggle", required: false },
          { id: "rcv_compagnia_precedente", text: "Compagnia precedente", type: "text", required: false, condition: { field: "rcv_polizza_precedente", value: true } },
        ],
      },
    ],
  },
};
